// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bin/" + chunkId + "." + {"70":"95b549aa32aa9428fbf7","404":"6c210f5db729d0a2f2bd"}[chunkId] + ".min.js";
};